<template>
  <div
    style="min-height: 100vh; background-color: #f7f8fc; padding-bottom: 20px"
  >
    <div class="taskBg">
      <div
        class="top_bg"
        style="background-image: url('img/task/face_card_bg.png');margin-top: 50px !important;"
      >
        <div class="task_title_ padding-sm">
          <img
            class="task_back"
            src="img/backb.png"
            alt=""
            @click="closePage"
          />
          <span style="color: #111111">任务中心</span>
        </div>
        <div class="user_info">
            <div>
                <div  class="my_coin" style="display: flex;justify-content: center;align-items: center;">
                    <img class="icon_small" src="img/task/yb_icon.png" alt="">
                    <span>我的趣币</span>
                </div>
                <div class="coin_num">{{userInfo.flower}}</div>
            </div>
            <div class="coin" style="background-image: url('img/task/yb_icon_big.png');"></div>
        </div>
      </div>
      <div class="task_box">
        <div class="task_tit">每日任务</div>
        <div class="day-task-box">
          <div class="task-content">
            <div
              class="task-item"
              v-for="(item, index) in dayTaskList"
              :key="index"
            >
              <div class="task-item-left">
                <div class="task-text" style="color: #111111">
                  {{
                    index+1+'.'+
                    item.task_name +
                    "(" +
                    item.finish_num +
                    "/" +
                    item.task_num +
                    ")"
                  }}
                </div>
                <div class="exp-flower">
                  <div class="exp-flower-right">
                    <img class="hua-icon" src="img/task/yb_icon.png" alt="" />
                    <span style="color: #111111">{{ item.flower }}</span>
                  </div>
                  <!-- <div class="exp-flower-right">
                  <img class="hua-icon" src="img/card_icon.png" alt="">
                  <span>1游园卡</span>
                </div> -->
                </div>
              </div>
              <div class="task-item-right">
                <img
                  v-if="item.status == 1"
                  src="img/task/receive_unclick.png"
                  alt=""
                  @click="clickRed(item)"
                />
                <img
                  v-if="item.status == 2"
                  src="img/task/receive_clicked.png"
                  alt=""
                />
                <img
                  v-if="item.status == 0"
                  src="img/task/gogogo.png"
                  alt=""
                  @click="goFinish(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <wechat-share @childFn="parentFn" />
  </div>
</template>

<script>
import "@/assets/css/base.css";
import "@/assets/css/index.css";
// import "@/assets/fonts/ShiShangZhongHeiJianTi.ttf"
// import { welFareList, getLuckyWelfare, getWelfare, newUserGetRedPacket, inviteLevelDetails, getFlowers } from "@/api/api";
import { levelInfo, taskList, getTaskPrize } from "@/api/levelUp";
import NavBar from "@/components/navBar.vue";
import WechatShare from "@/components/wechatShare.vue";
export default {
  name: "task",
  components: {
    NavBar,
    WechatShare,
  },
  data() {
    return {
      userInfo: {},
      dayTaskList: [],
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.getTaskList();
    this.getLevelInfo();
  },
  methods: {
    getTaskList() {
      taskList().then((res) => {
        this.dayTaskList = res.data[1];
      });
    },
    getLevelInfo() {
      levelInfo().then((res) => {
        this.userInfo = res.data;
      });
    },
    closePage() {
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
    goFinish(d) {
      console.log(d);
      this.$bridge.callhandler(d.route, d.room_id, (data) => {
        // 处理返回数据
      });
    },

    // 点击任务领取按钮
    clickRed(item) {
      console.log(item);
      getTaskPrize({ task_id: item.id })
        .then(
          (response) => {
            this.$toast("领取成功~");
            this.getTaskList();
            this.getLevelInfo()
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
    //
    parentFn(url) {
      this.img = url;
    },
    // 去邀请新用户
    goInvite() {
      var img = this.img;
      let str = {
        url: img,
      };
      let param = JSON.stringify(str);
      let _this = this;
      this.$bridge.callhandler("doShareTask", param, (data) => {
        // 处理返回数据
      });
    },
  },
  watch: {
    $route: "fetchData",
  },
};
</script>